import { API_ENDPOINTS } from "constants";
import { useFetchData } from "./apiHooks";
import Avatar from "react-avatar";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { emailLanguageCodes } from "constants";
import Flag from "react-world-flags";

export const useLanguageOptions = () => {
    const languageOptions = () => {
        const options = emailLanguageCodes.map(item => ({ 
            value: item.label, 
            label: item.label, 
            element: <Flag code={item.code} height="20"/>
        })) || [];

        options.unshift({
            value: null, 
            label: "Select",
            element: <IconButtonWithTooltip icon={faCircleQuestion} type='IconOnly' size="2xl"/>}
        ); 
        return options;
    };

    return { languageOptions: languageOptions() };
};

